import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import DataTable from '../DataTable';
import Spinner from '../Spinner';
import { toJS } from 'mobx';
import _ from 'lodash';

@inject('dataSourceStore', 'daqProcessorStore')
@observer
class DataSourceList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  }

  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillMount() {
    const { dataSourceStore } = this.props;
    if (!dataSourceStore.isLoading && !dataSourceStore.items.length) dataSourceStore.fetchItems();
  }

  handleDelete(idOrIds) {
    console.log('handleDelete', idOrIds);
    this.props.dataSourceStore.removeItems(idOrIds);
  }

  slug = 'daq/data-source';
  columns = [
    { key: 'name', label: 'Name' },
  ];

  allColumns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Name' },
    { key: 'description', label: 'Description' },
    { key: 'provider', label: 'Provider' },
  ];

  actions = [
    { label: 'View', link: '/daq/data-source/{id}/data-origin' },
  ];

  render() {
    const { rolePermissionStore, dataSourceStore, children, main, sidebar } = this.props;
    if (dataSourceStore.isLoading) return <Spinner />

    let data = dataSourceStore.items.map(item => _.pick(item, this.allColumns.map(item => item.key)))

    if (!main) {
      return (
        <div>
          <DataTable
            data={data}
            slug={this.slug}
            columns={this.allColumns}
            actions={rolePermissionStore.validateRole('view data-origin') ? this.actions : []}
            onDelete={this.handleDelete}
            caption="Data Sources"
            allowAdd allowDelete allowEdit
            resource='data-source'
            isLoading={dataSourceStore.isLoading}
          />
          {children}
        </div>
      );
    }

    return (
      <div className="inline-grid">
        <div className="side-table">
          <DataTable
            data={data}
            slug={this.slug}
            columns={this.columns}
            actions={this.actions}
            onDelete={this.handleDelete}
            caption="Data Sources"
            resource='data-source'
            isLoading={dataSourceStore.isLoading}
          />
          <br />
          <div>{sidebar}</div>
        </div>
        <div className="flex-grow">
          {main}
        </div>
      </div>
    );
  }
}

export default DataSourceList;



// WEBPACK FOOTER //
// ./src/components/DataSource/DataSourceList.js